export const LAYOUT_GRID = 'grid';
export const LAYOUT_COLUMN = 'column';

export const LAYOUT_OPTION = {
  GRID: 'grid',
  COLUMN: 'column',
} as const;

export const STICKY_HEADER_HEIGHT = 6.1;
export const NEGATIVE_STICKY_HEADER_HEIGHT = -STICKY_HEADER_HEIGHT;
export const MOBILE_ALPHABET_PICKER_HEIGHT = 5 * 10;

export const NAVBAR_HEIGHT = 6;
export const NAVBAR_HEIGHT_PX = 6 * 10;
